import {
  IonInput,
  IonItem,
  IonButton,
  IonCol,
  IonGrid,
  IonContent,
  IonRow,
  IonPage,
  IonToast,
  IonList,
  IonCard,
  IonCardContent,
  IonCardSubtitle,
  IonCardTitle,
  IonCardHeader,
  IonIcon,
  IonLabel,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonFab,
  IonFabButton,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonNote,
  IonSlides,
  IonSlide,
  IonModal,
  IonTitle,
  IonButtons,
  IonToolbar,
  IonHeader,
  IonActionSheet,
  IonMenuButton,
  IonSearchbar,
  IonRippleEffect,
  IonText,
  IonThumbnail,
  IonMenu,
  IonImg,
  IonFooter,
  IonListHeader,
  IonTextarea,
  IonBadge
} from '@ionic/vue'

export default {
  install: (app) => {
    let comp = [
      IonInput,
      IonItem,
      IonButton,
      IonCol,
      IonGrid,
      IonContent,
      IonRow,
      IonPage,
      IonToast,
      IonList,
      IonCard,
      IonCardContent,
      IonCardSubtitle,
      IonCardTitle,
      IonCardHeader,
      IonIcon,
      IonLabel,
      IonInfiniteScroll,
      IonInfiniteScrollContent,
      IonTabBar,
      IonTabButton,
      IonTabs,
      IonFab,
      IonFabButton,
      IonItemOption,
      IonItemOptions,
      IonItemSliding,
      IonNote,
      IonSlides,
      IonSlide,
      IonModal,
      IonTitle,
      IonButtons,
      IonToolbar,
      IonHeader,
      IonActionSheet,
      IonMenuButton,
      IonSearchbar,
      IonRippleEffect,
      IonText,
      IonThumbnail,
      IonMenu,
      IonImg,
      IonFooter,
      IonListHeader,
      IonTextarea,
      IonBadge
    ]
    comp.forEach((el) => {
      if (el.displayName) {
        app.component(el.displayName, el)
      } else if (el.name != '') {
        app.component(el.name, el)
      }
    })
  }
}
